export default __webpack_public_path__ + "static/media/logo.ca375c65.svg";